import styled from 'astroturf/react';
import Svg from 'src/components/Svg';
import s from '../Capbox.styles';

const CapboxDigitalLearningWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    margin: 15px;
`;

const CapboxDigitalLearningTitle = styled('h2')`
  font-size: var(--ph-text-md);
  font-family: var(--ph-font-family-lato-heavy);
  line-height: 19px;
  color: var(--dark-blue);
`;

const CapboxDigitalLearningLogo = styled(Svg)`
    margin: 45px 0px 15px;
    width: 131px;
`;

const CapboxDigitalLearningDescription = styled('div')`
    font-size: var(--ph-text-sm);
    font-family: var(--ph-font-family-lato-bold);
    color: var(--dark-blue);
`;

const CapboxDigitalLearningMyCourses = styled('div')`
    font-size: 11px;
    font-family: var(--ph-font-family-lato-regular);
    color: var(--dark-green-100);
    cursor: pointer;
    width: fit-content;
    padding: 0 10px;
    transform: translateX(-10%);
    transition: transform 0.5s;
    &[class*='disableLink']{
        cursor: none;
        pointer-events: none;
    }
    &:hover{
       transform: translateX(0);
       background: var(--cyan-green-30);
       padding-left: 10px;
       text-decoration: underline;
       text-underline-offset: 2px;
       &:after{        
        text-decoration: none !important;
        display: inline-block;
       }
    }
    &:after{
        content: '\e902';
        padding-left: 15px;
        vertical-align: middle;
        font-size: 12px;
        color: var(--dark-green-100);
        font-family: "icon";
    }
`;

export default {
    ...s,
    CapboxDigitalLearningWrapper,
    CapboxDigitalLearningTitle,
    CapboxDigitalLearningLogo,
    CapboxDigitalLearningDescription,
    CapboxDigitalLearningMyCourses
}  
